import { useRef, useState } from "react";
import { UploadCloud, FileText, ImageIcon, X, Loader2 } from "lucide-react";
import api from "@/lib/api";
import { toast } from "sonner";

export const FileDropzone = ({ accept, kind = "archivo", value, filename, onUploaded, onClear, testid }) => {
  const inputRef = useRef(null);
  const [uploading, setUploading] = useState(false);

  const handleFile = async (file) => {
    if (!file) return;
    setUploading(true);
    const fd = new FormData();
    fd.append("file", file);
    try {
      const { data } = await api.post("/upload", fd, { headers: { "Content-Type": "multipart/form-data" } });
      onUploaded(data.path, data.filename);
      toast.success("Archivo subido");
    } catch (e) {
      toast.error("No se pudo subir el archivo");
    } finally {
      setUploading(false);
    }
  };

  if (value) {
    const isPdf = (filename || "").toLowerCase().endsWith(".pdf");
    return (
      <div className="flex items-center gap-2 rounded-md border border-slate-200 bg-slate-50 px-3 py-2" data-testid={`${testid}-file`}>
        {isPdf ? <FileText className="h-4 w-4 text-orange-600 shrink-0" /> : <ImageIcon className="h-4 w-4 text-orange-600 shrink-0" />}
        <span className="text-sm text-slate-700 truncate flex-1">{filename}</span>
        <button type="button" onClick={onClear} className="text-slate-400 hover:text-red-500 transition-colors" data-testid={`${testid}-clear`}>
          <X className="h-4 w-4" />
        </button>
      </div>
    );
  }

  return (
    <button type="button" onClick={() => inputRef.current?.click()} disabled={uploading}
      className="w-full rounded-md border-2 border-dashed border-slate-300 hover:border-orange-500 hover:bg-orange-50/40 transition-colors py-4 flex flex-col items-center justify-center gap-1 text-slate-500"
      data-testid={testid}>
      {uploading ? <Loader2 className="h-5 w-5 animate-spin" /> : <UploadCloud className="h-5 w-5" />}
      <span className="text-xs font-medium">{uploading ? "Subiendo…" : `Subir ${kind}`}</span>
      <input ref={inputRef} type="file" accept={accept} className="hidden"
        onChange={(e) => handleFile(e.target.files?.[0])} />
    </button>
  );
};
